import { makeStyles } from "@material-ui/core";
import MyModal from "../../CustomComponents/MyModal";
import { useDataLayerValue } from "../../Reducer/DataLayer";
import StorySlider from "./StorySlider";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { useState } from "react";

const Story = (props) => {
  const classes = useStyles();

  const [{ stories }, dispatch] = useDataLayerValue();
  const [isTrue, setIsTrue] = useState(false);

  // console.log(isTrue);
  return (
    <div className={classes.story}>
      <div className={classes.slidingStory}>
        {stories?.map((val, index) => {
          return (
            <div
              className="singleStory"
              key={index}
              onClick={() => {
                setIsTrue(true);
              }}
            >
              <MyModal
                isTrue={isTrue}
                buttonsTrue={false}
                img={
                  <div className={classes.storyPreview}>
                    <img src={val?.images[0]} alt="img 1" />
                    <h6>{val?.heading}</h6>
                  </div>
                }
              >
                {/* {val?.yt_embeded_news} */}
                <StorySlider index={index} />
              </MyModal>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Story;

const useStyles = makeStyles((theme) => ({
  story: {
    // backgroundColor: "#588091",
    width: "inherit",
    display: "flex",
    flexDirection: "column",
    height: "inherit",
    maxHeight: "12rem",
    marginTop: "3rem",
    justifyContent: "flex-end",
    // overscrollBehaviorX: "none",
    // overflow: "hidden",
  },
  slidingStory: {
    flex: 1,
    // backgroundColor: "#018",
    width: "100%", 
    height: "inherit",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    overflowX: "auto",
    scrollBehavior: "smooth",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "& .singleStory": {
      borderRadius: ".7rem",
      // width: "40rem",
      height: "inherit",
      margin: ".625rem",
      // backgroundColor: "green",
      boxShadow: ".05rem -.05rem .75rem #a1a1a1, -.05rem .05rem .75rem #a1a1a1",
      // overflow: "hidden",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "7rem",

        margin: "0.65rem .25rem",
      },
    },
  },
  "& .showStory": {
    width: "5rem",
    height: "5rem",
  },
  storyPreview: {
    maxWidth: "12rem",
    borderRadius: "0.5rem",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    "& img": {
      flex: 1,
      width: "inherit",
      height: "7.5rem",
      objectFit: "cover",
      aspectRatio: "16/9",
      backgroundColor: "white",
      transform: "scale(1)",
      [theme.breakpoints.down("sm")]: {
        height: "6rem",
      },
    },
    "& h6": {
      // flex: 1,
      padding: ".12rem",
      margin: 0,
      backgroundColor: "rgb(35, 38, 39)",
      color: "white",
      height: "3.5rem",
      fontSize: ".8rem",
    },
  },
}));
